import { searchInvestorsPressReleaseDashboard as investorsPressReleaseDashboardMapper } from '../helpers/filters/investors-press-release-dashboard';
import { search } from './search';

export const FILTER_INVESTOR_PRESS_RELEASE_DASHBOARD_KEY =
  'investors-press-release-dashboard-filter';
export const searchInvestorsPressReleaseDashboard = search(
  investorsPressReleaseDashboardMapper
);
